import { Select } from "components/styleguide";
import TableType from "enums/TableType";

const { Option } = Select;

export const getTableTypeOptions = () => {
  return (Object.keys(TableType) as (keyof typeof TableType)[])
    .filter((key) => key !== "toDisplayName")
    .map((key) => {
      const value = TableType[key] as number;
      return (
        <Option value={value} key={`table-type-${value}`}>
          {TableType.toDisplayName(value)}
        </Option>
      );
    });
};
